import React from "react";

const FilterContext = React.createContext();

export default FilterContext;